import React from 'react'

// Libraries
import { Col, Container, Navbar, Row, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { AnimatePresence, m } from 'framer-motion'
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Parallax } from "react-scroll-parallax";
import { Helmet } from "react-helmet";
import { Link as ScrollTo } from "react-scroll"
import { SwiperSlide, Swiper } from 'swiper/react';
import { Keyboard } from "swiper/modules";
import { Autoplay } from "swiper/modules";

// Components
import { fadeIn, fadeInLeft, zoomIn } from '../Functions/GlobalAnimations'
import FooterStyle from '../Pages/Footer/Footer';
import MainHeader from "../Pages/Header/MainHeader";
import { IMAGE_PATHS } from '../Functions/Constant';
import { useNavigate } from "react-router-dom";
import Services from '../Components/Services';
import CustomIconWithText from '../Components/CustomIconWithText'
import Overlap from '../Components/Overlap/Overlap';
import CustomModal from '../Components/CustomModal'
import IconWithText from '../Components/IconWithText/IconWithText'
import HeaderForBus from "../Pages/Header/HeaderForBus";
import ButtonsVariant from '../Components/Button/ButtonVariant'; // Fixed: Use default import



const CustomIconWithTextData2 = [

    {
        icon: "line-icon-Navigation-LeftWindow yellow-class",
        title: "Own Your Reputation",
        content: "Take control of your career with ratings and reviews from people you've actually worked with."
    },
    {
        icon: "line-icon-Cursor-Click2 yellow-class",
        title: "Stand Out with Proof",
        content: "Showcase verified performance—not just claims—backed by real connections."
    },
    {
        icon: "line-icon-Like-2 yellow-class",
        title: "Replace the Resume",
        content: "Let your data-rich, AI-powered profile speak louder than a traditional CV."
    },
    {
        icon: "line-icon-Talk-Man yellow-class",
        title: "Grow with Every Role",
        content: "Carry your verified reputation across companies, roles, and industries—forever."
    },
    {
        icon: "line-icon-Paper-Plane yellow-class",
        title: "Get Noticed Faster",
        content: "Verified profiles help employers trust you instantly and cut through the noise."
    },
    {
        icon: "line-icon-Heart yellow-class",
        title: "Build Career Credibility",
        content: "Turn feedback into a trusted professional identity that opens new opportunities."
    }

]

const swiperData = [
    {
        img: "https://jobcritics.com/assets/img/biar/1st.webp",
        title: "Get Rated",
        content: "Receive verified reviews from people you’ve worked with."
    },
    {
        img: "https://jobcritics.com/assets/img/biar/2nd.webp",
        title: "Career Report",
        content: "Showcase your strengths with an AI-driven profile summary."
    },
    {
        img: "https://jobcritics.com/assets/img/biar/3rd.webp",
        title: "Privacy Control",
        content: "Share your ratings only with employers you trust."
    }
    ,
    {
        img: "https://jobcritics.com/assets/img/biar/10.webp",
        title: "Rate Others",
        content: "Help peers build credibility by sharing honest feedback."
    }
]


const Individual = (props) => {
    const swiperRef = React.useRef(null);
    const howItWorksSwiperRef = React.useRef(null);
    const serviceData5 = [
        {
            title: "Authentic Ratings & Reviews",
            icon: "feather-arrow-right",
            content: "Collect feedback from colleagues, managers, and peers to reflect your real strengths.",
            // link: "/page/about-me",
            // linkTitle: "More Info"
        },
        {
            title: "Rate Your Connections",
            icon: "feather-arrow-right",
            content: "Give feedback to colleagues and peers to help them build a trusted professional reputation.",
            // link: "/page/about-me",
            // linkTitle: "More Info"
        },
        {
            title: "AI-Generated Career Report",
            icon: "feather-arrow-right",
            content: "Turn your ratings into a credibility report you can share anywhere, anytime.",
            // link: "/page/about-me",
            // linkTitle: "More Info"
        }
    ]
    const TestimonialsData = [
        {
            name: 'Pallavi Chauhan',
            content: 'I created my profile on JobCritics and got feedback from my HR. It really helped me understand my strengths better.',
            img: "https://jobcritics.com/assets/img/biar/pallavi.webp",
            company: "Senior Executive Product",
            rating: 5
        },
        {
            name: 'Anupam Bhargav',
            content: "JobCritics helped me make a resume with ratings. It's a smart way to show my skills clearly and confidently.",
            img: "https://jobcritics.com/assets/img/biar/anupam.webp",
            company: "Sales Executive",
            rating: 5
        },
        {
            name: 'Amandeep Kaur',
            content: 'My teachers rated my profile on JobCritics. That feedback helped me stand out and get my first job easily.',
            img: "https://jobcritics.com/assets/img/biar/Aman.webp",
            company: "HR Admin Executive",
            rating: 5
        },
        {
            name: 'Nandini Kapoor',
            content: "JobCritics is a simple platform that connects you to many job opportunities. It's easy to use and worth trying.",
            img: "https://jobcritics.com/assets/img/biar/nandini.webp",
            company: "Business Analyst",
            rating: 5
        }
    ]
    const navigate = useNavigate();
    const jobcritic_usertype = localStorage.getItem("jobcritic_usertype");
    const handleReviewClick = () => {
        const jwtTokenJobcritic = localStorage.getItem("jwt_token_jobcritic"); // Check user_id in localStorage
        if (jwtTokenJobcritic) {
            if (jobcritic_usertype == 2) {
                navigate("/verifications");
            } else {
                navigate("/profile"); // If logged in, go to review form
            }
        } else {
            if (jobcritic_usertype == 2) {
                navigate("/business-login");
            } else {
                navigate("/login");  // If logged in, go to review form
            }
        }
    };
    return (
        <div style={props.style}>
            {/* <SideButtons /> */}
            {/* Header Start */}
            {jobcritic_usertype == 2 ? <HeaderForBus /> : <MainHeader />}
            {/* Header End */}
            <Helmet>
                {/* <meta
                    name="description"
                    content="Build your professional reputation with JobCritics—the world’s first platform for individual ratings and reviews, verified by employers."
                /> */}
                <meta property="og:title" content="JobCritics – Build Your Reputation with Verified Ratings" />
                <meta property="og:description" content="Collect authentic reviews from people you've worked with. Showcase your skills and prove your expertise with verified ratings on JobCritics." />
                <meta property="og:image" content="https://jobcritics.com/assets/img/biar/individual_og.webp" />
                <meta property="og:url" content="https://jobcritics.com/professionals" />
                <meta property="og:type" content="website" />


                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="JobCritics – Build Your Reputation with Verified Ratings" />
                <meta name="twitter:description" content="Collect authentic reviews from people you've worked with. Showcase your skills and prove your expertise with verified ratings on JobCritics." />
                <meta name="twitter:image" content="https://jobcritics.com/assets/img/biar/individual_og.webp" />
                <meta name="twitter:url" content="https://jobcritics.com/professionals" />

            </Helmet>
            <section className="py-[130px] overflow-hidden lg:py-[90px] sm:py-[75px] xs:py-[50px] !pt-[200px] xs:!pt-[75px] md:!pt-[75px]">
                <Container>
                    <Row className="items-center justify-center">
                        <Col lg={6} md={9} className="mb-[10px] md:mb-28 xs:text-center">
                            {/* <h2 className="heading-5 font-serif font-semibold  uppercase mb-[9px] black-class text-[22px]">Build Your Professional Reputation!</h2> */}
                            <h3 className="font-serif font-bold   mb-[35px] tracking-[-1px] text-black text-[56px] leading-[1.1]">Build Your Reputation with Verified Ratings!</h3>
                            <p className="w-[90%] xs:w-[100%] text-lg mb-[35px] leading-[38px] xs:text-xmd black-class !text-[32px] xs:leading-[1.2]">Get reviews from your work connections and showcase your skills.</p>


                            <ButtonsVariant
                                href="#"
                                ariaLabel="button"
                                onClick={handleReviewClick}
                                className="mx-[10px]"
                                variant="blackToWhite"
                                size="xl"
                                title="Create Your Profile"
                            />
                        </Col>
                        <Col lg={6} md={9} xs={12} className="px-[55px] md:pr-[50px] md:pl-[5px]">
                            <m.figure className="image-back-offset-shadow w-100">
                                <m.img
                                    className="rounded-[6px] w-auto h-auto"
                                    src={IMAGE_PATHS.ourservices02}
                                    alt="Build Your Reputation with Verified Ratings."
                                    width="572.5"
                                    height="436.53"
                                    initial={{ opacity: 0, x: "0", y: "0" }}
                                    whileInView={{ opacity: 1, x: "10px", y: "-20px" }}
                                    viewport={{ once: true }}
                                    transition={{ delay: 0.4, easing: "linear" }}
                                />
                                <m.span
                                    className="rounded-[6px]"
                                    {...{ ...fadeIn, animate: { x: "35px", y: "5px" } }}
                                ></m.span>
                            </m.figure>
                        </Col>
                    </Row>
                </Container>
            </section>

            <Helmet>
                <meta
                    name="description"
                    content="Build a lasting, verified professional reputation with JobCritics—trusted across roles and industries."
                />
            </Helmet>
            <section className="bj z-[1] relative py-[130px] lg:py-[90px] sm:py-[75px] xs:py-[50px]">
                <Container>
                    <Row className="justify-center">
                        <Col md={8} className="font-serif justify-center flex flex-col items-center mb-20 sm:mb-12">
                            {/* <span className="mb-[10px] inline-block uppercase font-medium yellow-class tracking-[1px]">Why JobCritics?</span> */}
                            <h5 className="text-darkgray font-semibold -tracking-[1px] xs:text-center">Build Your Professional Reputation for Life</h5>
                            {/* <p className="mb-[40px]">JobCritics helps you build a verified reputation that stays with you—across jobs, industries, and time.</p> */}
                        </Col>
                    </Row>
                    <Row className="justify-center">
                        <Col lg={12} md={10} xs={12} className="xs:px-0">
                            <Services grid="row-cols-lg-3 row-cols-1 md:my-0 md:mx-auto gap-y-[15px]" theme='service-style-05' className=" " data={serviceData5} animation={fadeIn} />
                        </Col>
                    </Row>
                </Container>
            </section>

            <Helmet>
                <meta
                    name="description"
                    content="JobCritics lets individuals build verified reputations through ratings, reviews, and AI-powered credibility reports."
                />
            </Helmet>
            <m.section id="services" className="relative py-[130px] lg:py-[90px] sm:py-[75px] xs:py-[50px]" {...fadeIn}>
                <Parallax className="lg-no-parallax bg-cover absolute -top-[50px] left-0 w-full h-[100vh]" translateY={[-50, 50]} style={{ backgroundImage: `url(/assets/img/webp/our-services-17.webp)` }}></Parallax>
                <Container>
                    <Row>
                        <Col xl={7} lg={8} md={12} className="md:mb-[40px]">
                            <Row>
                                <Col className="relative mb-12 lg:mb-[40px] sm:mb-[7.5rem] xs:mb-[4.5rem]">
                                    {/* <span className="font-serif mb-[20px] yellow-class inline-block uppercase font-medium tracking-[1px]">What is JobCritics? </span> */}
                                    <h5 className="font-serif font-semibold text-darkgray text-[26px] xs:text-center">The World’s First Ratings Platform for Individuals</h5>
                                    <p className="mb-[40px]">JobCritics is a professional reputation platform where individuals receive verified ratings and reviews from people they’ve worked with. These ratings are turned into an AI-powered credibility report that replaces traditional resumes, helping you stand out with proof—not promises.</p>
                                    <div className="flex xs:justify-center">
                                        <div
                                            onClick={() => howItWorksSwiperRef.current?.swiper.slidePrev()}
                                            className="btn-slider-next transition-default rounded-full flex justify-center items-center text-black bg-transparent border-[1px] border-mediumgray right-inherit left-[65px] h-[40px] w-[40px] cursor-pointer hover:shadow-[0_0_20px_rgba(0,0,0,0.15)] hover:border-white hover:bg-white"
                                        >
                                            <button className="text-xmd leading-none"><i className="feather-arrow-left"></i></button>
                                        </div>
                                        <div
                                            onClick={() => howItWorksSwiperRef.current?.swiper.slideNext()}
                                            className="btn-slider-prev transition-default rounded-full flex justify-center items-center text-black right-inherit border-[1px] border-mediumgray h-[40px] w-[40px] ml-[10px] cursor-pointer hover:shadow-[0_0_20px_rgba(0,0,0,0.15)] hover:border-white hover:bg-white"
                                        >
                                            <button className="text-xmd leading-none"><i className="feather-arrow-right"></i></button>
                                        </div>
                                    </div>
                                </Col>
                                <Col>
                                    <Swiper
                                        ref={howItWorksSwiperRef} // Use the new ref here
                                        effect="slide"
                                        modules={[Keyboard, Autoplay]}
                                        keyboard={{ enabled: true, onlyInViewport: true }}
                                        slidesPerView={1}
                                        loop={true}
                                        autoplay={{ delay: 2500, disableOnInteraction: false }}
                                    >
                                        {swiperData.map((item, i) => (
                                            <SwiperSlide key={i}>
                                                <div className="border border-mediumgray rounded-[4px] overflow-hidden mr-[5px] xs:mr-0">
                                                    <Row className="g-0 row-cols-1 row-cols-sm-2">
                                                        <Col className="cover-background xs:h-[300px] xs:w-[400px] md:w-[250px]" style={{ backgroundImage: `url(${item.img})` }}></Col>
                                                        <Col>
                                                            <div className="p-16 lg:p-12">
                                                                <span className="font-serif text-darkgray font-medium inline-block mb-[15px] text-xmd">{item.title}</span>
                                                                <p className="mb-[25px]">{item.content}</p>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={4} md={12} xl={{ offset: 1 }}>
                            <div className="sticky top-0">
                                <div className="ourservice-list relative bg-gradient-to-bl from-[#FFBF00] via-[#FFBF00] to-[#FFDF80] w-full overflow-hidden rounded-[4px] p-16 lg:p-12 md:p-16 xs:text-center">
                                    <i className="line-icon-Cursor-Click2 text-[11rem] leading-[11rem] text-darkgray opacity-20 absolute -top-[20px] -left-[30px]"></i>
                                    <h6 className="font-serif font-medium  mb-[35px] sm:mb-[15px] relative z-[1] text-black">Simple Steps to Build a Credible Professional Reputation</h6>
                                    <ul className="list-style-03 font-serif ">
                                        <li className="border-[#ffffff33]  !py-[10px] px-0 border-b mb-0 text-black xs:flex xs:justify-center">Create Your Profile</li>
                                        <li className="border-[#ffffff33]  !py-[10px] px-0 border-b mb-0 text-black xs:flex xs:justify-center">Collect Ratings & Reviews</li>
                                        <li className="border-[#ffffff33]  !py-[10px] px-0 border-b mb-0 text-black xs:flex xs:justify-center">Get Career Report</li>
                                        <li className="border-[#ffffff33]  !py-[10px] px-0 border-b mb-0 text-black xs:flex xs:justify-center">Review Your Connections</li>
                                    </ul>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </m.section>

            <section className="text-center relative grid-rows-3 grid-cols-2 py-[130px] opacity-[1] overflow-hidden bj lg:py-[90px] sm:py-[75px] xs:py-[50px]" >
                <Container>
                    <Col className="relative mb-12 lg:mb-[40px] sm:mb-[7.5rem] xs:mb-[4.5rem]">
                        <h5 className="font-serif font-semibold text-darkgray">Unique Value Propositions for Individuals</h5>
                    </Col>
                    <CustomIconWithText
                        grid="row-cols-1 row-cols-lg-3 row-cols-sm-2"
                        theme="custom-icon-with-text02"
                        data={CustomIconWithTextData2}
                        animationDelay={0.3}
                        animation={fadeIn} />
                </Container>
            </section >

            <m.section className="overflow-hidden py-[160px] !pb-[240px] lg:py-[120px] md:py-[95px] sm:py-[80px] xs:py-[50px]" {...fadeIn}>
                <Container>
                    <Row className="items-end">
                        <Col className="col-12 col-xl-3 col-lg-4 relative pt-8 md:mb-16">
                            {/* <span className="font-serif font-medium text-fastblue block mb-[20px] lg:mb-[15px]">Loved by our customers</span> */}
                            {/* <span className="font-serif font-semibold  yellow-class tracking-[1px] inline-block uppercase mb-[20px] sm:mb-[10px]">Loved by Users</span> */}
                            <h6 className="font-serif font-medium text-darkgray -tracking-[.5px] mb-14 lg:w-[100%] xs:text-center">Discover how our platform empowered career growth.</h6>

                            <div className="flex xs:justify-center">
                                <div onClick={() => swiperRef.current.swiper.slidePrev()} className="btn-slider-next rounded-full flex justify-center items-center text-black hover:shadow-[0_0_15px_rgba(0,0,0,0.1)] bg-white right-inherit border border-mediumgray left-[65px] h-[40px] w-[40px] cursor-pointer" >
                                    <button className="text-xmd"><i className="feather-arrow-left"></i></button>
                                </div>
                                <div onClick={() => swiperRef.current.swiper.slideNext()} className="btn-slider-prev rounded-full flex justify-center items-center text-black right-inherit h-[40px] w-[40px] hover:shadow-[0_0_15px_rgba(0,0,0,0.1)] border border-mediumgray ml-[10px] cursor-pointer" >
                                    <button className="text-xmd"><i className="feather-arrow-right"></i></button>
                                </div>
                            </div>
                        </Col>
                        <Col className="col-12 col-lg-8 offset-xl-1">
                            <Swiper
                                className="black-move swiper-pagination-medium h-full min-w-[1170px] md:min-w-full"
                                modules={[Autoplay]}
                                ref={swiperRef}
                                spaceBetween={30}
                                slidesPerView={1}
                                observer={true}
                                observeParents={true}
                                loop={true}
                                autoplay={{
                                    delay: 4500,
                                    disableOnInteraction: false,
                                }}
                                keyboard={{
                                    enabled: true,
                                    onlyInViewport: true
                                }}
                                breakpoints={{ 992: { slidesPerView: 3 }, 768: { slidesPerView: 2 } }}
                            >
                                {
                                    TestimonialsData.map((item, i) => {
                                        return (
                                            <SwiperSlide key={i}>
                                                <div className="py-12 px-12 px-mb-14 bg-white border border-mediumgray rounded-[6px] md:py-12 md:px-14">
                                                    <div className="flex">
                                                        <div className="mr-[20px]">
                                                            <img loading="lazy" className="rounded-full w-[65px] h-[65px]" src={item.img} alt="Discover how our platform empowered career growth." />
                                                        </div>
                                                        <div className="">
                                                            <div className="mb-[15px] text-xxs text-[#ff9c00]">
                                                                <i className="fas fa-star"></i>
                                                                <i className="fas fa-star"></i>
                                                                <i className="fas fa-star"></i>
                                                                <i className="fas fa-star"></i>
                                                                <i className="fas fa-star"></i>
                                                            </div>
                                                            <div className="text-darkgray text-md font-serif font-medium leading-[12px]">{item.name}</div>
                                                            {item.company && <span className="text-sm">{item.company}</span>}
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <p className="mt-[30px]">{item.content}</p>
                                                    </div>
                                                </div>
                                            </SwiperSlide>
                                        )
                                    })
                                }
                            </Swiper>
                        </Col>
                    </Row>
                </Container>
            </m.section>
            <m.section className="bg-black " {...fadeIn}>
                <Container className="sm:pb-[50px]">
                    <Row className="xs:mx-0">
                        <Overlap className="relative bg-gradient-to-tr from-[#FFBF00] via-[#FFBF00] to-[#FFDF80] rounded-[5px] px-[0px] py-[65px] md:p-[40px] xs:px-[20px] flex sm:flex sm:justify-center sm:items-center sm:flex-col">
                            <Col lg={{ span: 8, offset: 1 }} md={8} sm={8} className="text-start sm:mb-[20px]">
                                <h5 className="font-serif font-medium text-darkgray w-[95%] mb-0 lg:w-full sm:text-center">CIBIL is for Your Financial Credibility<br />JobCritics is for Your Career Credibility.</h5>
                            </Col>
                            <Col lg={{ span: 4 }} md={4} sm={8} className="ourservice-start-your-project text-center flex items-center md:text-start sm:justify-center">

                                <span className="inline-flex flex-row items-center justify-center">
                                    <ButtonsVariant
                                        onClick={handleReviewClick}
                                        ariaLabel="button"
                                        href="#"
                                        className="mx-[10px]"
                                        variant="whiteToBlack"
                                        size="lg"
                                        title="Get Started"
                                    />
                                </span>
                                {/* Modal Component End */}
                            </Col>
                        </Overlap>
                    </Row>
                </Container>
                {/* footer Start */}
                <FooterStyle theme="dark" className="bg-black text-[#828282] seo-agency-footer_06" />

                {/* footer End */}
            </m.section>


            {/* Section End */}

            {/* Section Start */}

        </div>
    )
}

export default Individual
